import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import Template1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Template1";
import Ticket5 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket5";
import Ticket6 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket6";
import Ticket7 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket7";
import Ticket8 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket8";
import Ticket9 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket9";
import Band1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band1";
import Band2 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band2";
import Band3 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band3";
import {
  Container,
  Grid,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import { notification } from "antd";

const SelecetedTicket = () => {
  const location = useLocation();
  const selectedTicket = location.state?.eventData || {};
  const ticketCategories = selectedTicket.ticketCategories || [];
  const navigator = "ct";
  const [downloading, setDownloading] = useState(false);

  const ticketComponents = {
    7: Template1,
    8: Ticket5,
    9: Ticket6,
    10: Ticket7,
    11: Ticket8,
    12: Ticket9,
    13: Band1,
    14: Band2,
    default: Band3,
  };

  const TicketTemplate =
    ticketComponents[selectedTicket?.id] || ticketComponents.default;

  const handleDownload = async (id) => {
    setDownloading(true);
    const element = document.getElementById(id);
    if (!element) {
      setDownloading(false);
      return;
    }

    try {
      const dataUrl = await toPng(element);
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "Ticket.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading ticket:", error);
    } finally {
      setDownloading(false);
    }
  };

  const handleDownloadAll = async () => {
    setDownloading(true);

    try {
      const ticketsContainers = document.querySelectorAll(".ticket-container"); // Select all ticket elements
      if (!ticketsContainers.length) {
        throw new Error("No tickets found");
      }

      // Create a new PDF instance
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      let yPos = 10;

      for (let i = 0; i < ticketsContainers.length; i++) {
        const ticket = ticketsContainers[i];
        const dataUrl = await toPng(ticket, { cacheBust: true });
        const imgProps = pdf.getImageProperties(dataUrl);
        const imgWidth = pdfWidth - 20;
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

        if (yPos + imgHeight > pdfHeight - 10) {
          pdf.addPage();
          yPos = 10;
        }
        pdf.addImage(dataUrl, "PNG", 10, yPos, imgWidth, imgHeight);
        yPos += imgHeight + 10;
      }

      pdf.save("All_Tickets.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
      notification.error({
        message: "Failed to generate PDF!",
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Container sx={{ padding: "10px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          variant="h5"
          fontWeight={600}
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.5rem" },
          }}
        >
          {/* Generated Tickets: */}
        </Typography>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={handleDownloadAll}
          disabled={downloading}
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            whiteSpace: "nowrap",
          }}
        >
          Download All
        </Button>
      </Box>

      <Grid
        container
        spacing={2}
        sx={{ borderRadius: "10px", width: "100%", overflow: "hidden" }}
      >
        {ticketCategories.length < 1 && (
          <Typography ml={2} variant="body1">
            Ticket categories doesn't exist any more.
          </Typography>
        )}
        {ticketCategories?.map((category, index) =>
          Array.from({ length: category.quantity }).map((_, i) => {
            const ticketId = `${index}-${i}`;
            return (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                key={ticketId}
                sx={{ overflowX: "auto", overflowY: "hidden" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    cursor: "pointer",
                    "&:hover .download-btn": { opacity: 1 },
                  }}
                >
                  <Box
                    id={ticketId}
                    className="ticket-container"
                    sx={{ minWidth: "450px" }}
                  >
                    <TicketTemplate
                      navigator={navigator}
                      ticket={{ ...selectedTicket, price: category.price }}
                      type={category.typeName}
                    />
                  </Box>
                  <Button
                    variant="contained"
                    size="small"
                    className="download-btn"
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      opacity: 0,
                      transition: "opacity 0.3s",
                    }}
                    onClick={() => handleDownload(ticketId)}
                    disabled={downloading}
                  >
                    {downloading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : (
                      <DownloadIcon fontSize="small" />
                    )}
                  </Button>
                </Box>
              </Grid>
            );
          })
        )}
      </Grid>
    </Container>
  );
};

export default SelecetedTicket;
